import React, { useRef, useState, useEffect } from 'react';
import { Play } from "lucide-react";
import { useParams } from 'react-router-dom';
import {Card, Button, CardText, } from 'react-bootstrap';
import { Link, } from 'react-router-dom';
import Muted from './assets/muted.svg';
import Unmuted from './assets/unmuted.svg';
import Replay from './assets/Replay.svg';

function MainTPlayer() {
  const [error, setError] = useState(null);
  const videoRef = useRef(null);
  const [muted, setMuted] = useState(true);
  const { moviename: movieParam } = useParams();
  const [movieData, setMovieData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [showPoster, setShowPoster] = useState(true);

  useEffect(() => {
    if (videoRef.current) {
      setMuted(videoRef.current.muted);
    }
  }, []);

  const toggleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted;
      setMuted(videoRef.current.muted);
    }
  };

  const handleReplay = () => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play();
    }
  };

  useEffect(() => {
    const fetchMovieData = async () => {
      try {
        const response = await fetch(`https://second-team-productions.onrender.com/newmovies`);
        if (!response.ok) {
          throw new Error('Failed to fetch movie data');
        }
        const data = await response.json();
        const filteredMovies = data.filter(movie => movie.moviename === 'SEVEN SAMURAI');
        

        if (filteredMovies.length > 0) {
          setMovieData(filteredMovies[0]);
          setIsLoaded(true);
        } else {
          throw new Error('Movie data not found');
        }
      } catch (error) {
        console.error('Error fetching movie data:', error);
        setError(error.message);
      }
    };

    fetchMovieData();
  }, [movieParam]);

  useEffect(() => {
  if (!isLoaded) return;
  setShowPoster(true);
  const timer = setTimeout(() => setShowPoster(false), 5000);
  return () => clearTimeout(timer);
}, [isLoaded]);

const handleVideoEnded = () => {
  setShowPoster(true);
};

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!isLoaded) {
    return <div></div>;
  }

const CF_BASE = "https://d3duw5o0obopn7.cloudfront.net";
const posterUrl = `${CF_BASE}/ssmainimage.jpeg`;



  return (
      <div 
      style={{
        position: 'relative',
        zIndex: 0,
        width: '100%',
        height: '100%',
        minHeight: '420px',
        maxHeight: '520px',
        backgroundColor: 'black',
        overflow: 'hidden',
        // maxWidth: '1200px',
        // margin: '1rem auto',
        // overflow: 'hidden',
        // backgroundColor: 'rgba(20, 19, 19, 0.7)',
          // backdropFilter: 'blur(8px)', 
          // WebkitBackdropFilter: 'blur(8px)',
         
          overflow: 'hidden',
           borderRadius: "30px",
        border: '1px solid rgba(70, 68, 68, 0.03)',
        // boxShadow: `
        //   0 2px 0 rgba(255, 255, 255, 0.03) inset,
        //   0 -2px 0 rgba(0, 0, 0, 0.5) inset,
        //   0 12px 24px rgba(0, 0, 0, 0.6),
        //   0 32px 64px rgba(0, 0, 0, 0.5),
        //   0 64px 100px rgba(0, 0, 0, 0.35)
        // `,
        
        // maskImage: 'linear-gradient(to bottom, white 80%, transparent 100%)',
        // WebkitMaskImage: 'linear-gradient(to bottom, white 80%, transparent 100%)',
        // transition: 'mask-image 0.3s ease',
        ...(window.innerWidth <= 768 ? { maxHeight: '65vh', minHeight: 'auto' } : {}),
      }}>
        <div>
<video
  playsInline
  autoPlay
  muted
  onEnded={handleVideoEnded}
  src={`${CF_BASE}/SSTrailer.mp4`}
  style={{
    width: '100%',
    height: '100%',
      minHeight: '420px',
        maxHeight: '520px',
    objectFit: 'contain', 
    position: 'relative',
    zIndex: 0,
  }}
  ref={videoRef}
>
</video>
  {showPoster && (
    <img
      src={posterUrl}
      alt={`${movieData?.moviename} poster`}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        borderRadius: "30px",
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: 1,
        backgroundColor: 'black',

      }}
    />
  )}
        </div>


      <div className='col-6 card-overlay' 
             style={{ 
              position: 'absolute', 
              top: '35%', 
              marginLeft: '3%',
              zIndex: 2,
              backgroundColor: 'none', 
              borderRadius: '8px', // 
              padding: '1rem',    
              maskImage: `
              linear-gradient(to bottom, white 0%, white 95%, transparent 100%),
              linear-gradient(to top, white 0%, white 90%, transparent 100%),
              linear-gradient(to right, white 0%, white 90%, transparent 100%)`,
            WebkitMaskImage: `
              linear-gradient(to bottom, white 0%, white 95%, transparent 100%),
              linear-gradient(to top, white 0%, white 90%, transparent 100%),
              linear-gradient(to right, white 0%, white 90%, transparent 100%)`,
            WebkitMaskComposite: 'destination-in',
            maskComposite: 'intersect',
            transition: 'mask-image 0.9s ease',
            
            }}  >
                <Card>
                  <h6 
                    className='title-font' 
                    style={{ 
                      color: movieData?.fontColor,
                      textShadow: movieData?.textShadow 
                    }}
                  >
                    {movieData?.moviename}
                  </h6>
                   <div style={{ display: 'flex', gap: '.5rem',}}>  
                    <Card.Text>{movieData && movieData.year}</Card.Text>
                    <Card.Text as="span" style={{ opacity: 0.8 }}>•</Card.Text>
                    <Card.Text>{movieData && movieData.runtime}</Card.Text>
                   </div>
                  {/* <Card.Text> 
                    {movieData?.moviedescription}
                  </Card.Text> */}
                  <Link to={`/${movieData?.moviename}`}
                  style={{ textDecoration: 'none', }}
                  >
                  
                  <Button 
                  className="play-details-resume-button " 
                  style={{
                    backgroundColor: 'rgb(67, 66, 66)',
                    border: 'none',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    // gap: '0.5rem',
                    // padding: '0.5rem 1rem',
                    marginTop: '2%'
                  }} 
                >
             
                  <h5 className="play-details-resume-button-text"
                    style={{ 
                      margin: 0, 
                      flex: 1,
                      textAlign: 'left',
                      color: '#131212',
                    }}
                  >
                    Details
                  </h5>  
                </Button>
                  </Link>
                  <div 
          style={{
          position: 'absolute',
          top: '82%', 
          right: '8%',
          display: 'flex',
          alignItems: 'flex-end',
          gap: '10px', 
          zIndex: 2
        }}>

      {muted ? (
        <img
          src={Muted}
          alt="Muted Icon"
          onClick={toggleMute}
          style={{
            width: '2.5vw',
            height: '2.5vw',
            cursor: 'pointer',
            
          }}
        />
      ) : (
        <img
          src={Unmuted}
          alt="Unmuted Icon"
          onClick={toggleMute}
          style={{
            width: '2.5vw',
            height: '2.5vw',
            cursor: 'pointer',
          }}
        />
      )}
      <img
        src={Replay}
        alt="Replay Icon"
        onClick={handleReplay}
        style={{
          width: '2.5vw',
          height: '2.5vw',
          cursor: 'pointer',
          fill: 'white'
        }}
      />
      </div>
                </Card>
              </div>
    </div>
  );
}

export default MainTPlayer;
